import { useEffect, useState } from 'react';
import { createElement } from 'react';
import './index.scss';
import { Box } from '@alifd/next';
import ConditionGroup from './condition-group';
import { entityDataUtil } from 'oadp-common';
const OadpEntityButtonReadRule = function OadpEntityButtonReadRule({ children, name, id, entity, tableComponentRefId, defaultValue, label, style, type, size, onClick, disabled, __designMode, ...otherProps }) {
    const [condition, setConditionValue] = useState(defaultValue || {
        id: '0',
        operator: 'and',
        value: [
            {
                id: String(Date.now() + 1),
                attribute: '',
                operator: 'equals',
                valueType: 'MEMBER',
                value: '',
            }
        ]
    });
    const [attributeDataSource, setAttributeDataSource] = useState();
    useEffect(() => {
        try {
            const condition = {
                "model": "attribute",
                "condition": {
                    "attribute": "entityId",
                    "operator": "equals",
                    "value": entity,
                },
                "orderBy": [
                    {
                        "attribute": "createAt",
                        "operator": "desc"
                    }
                ],
                "pageNum": 1,
                "pageSize": 10000
            };
            entityDataUtil.selectPageListWithReferByCondition('attribute', condition, (response) => {
                console.log('response', response);
                response.data.list.forEach((item) => {
                    item.label = item.name || '';
                    item.value = item.logicalName || '';
                });
                setAttributeDataSource(response.data.list);
            });
        }
        catch (error) {
            console.error('OadpEntityButtonReadRule Failed to fetch field options:', error);
        }
    }, []);
    console.log('OadpEntityButtonReadRule props:', {
        children,
        name,
        id,
        entity,
        tableComponentRefId,
        defaultValue,
        label,
        style,
        type,
        size,
        onClick,
        disabled,
        __designMode,
        ...otherProps
    });
    if (__designMode === 'design') {
        onClick = (e) => {
            console.log('design mode OadpEntityButtonReadRule click');
        };
    }
    const handleButtonClick = () => {
        if (onClick) {
            console.log('OadpEntityButtonReadRule click condition', condition);
            onClick(condition);
        }
    };
    const handleAdd = (parentId, isGroup) => {
        const newItem = isGroup ? {
            id: String(Date.now()),
            operator: 'and',
            value: [{
                    id: String(Date.now() + 1),
                    attribute: '',
                    operator: 'equals',
                    valueType: 'MEMBER',
                    value: '',
                }, {
                    id: String(Date.now() + 2),
                    attribute: '',
                    operator: 'equals',
                    valueType: 'MEMBER',
                }]
        } : {
            id: String(Date.now()),
            attribute: '',
            operator: 'equals',
            valueType: 'MEMBER',
            value: '',
        };
        console.log("handleAdd newItem", newItem);
        const newData = addItemToParent(condition, parentId, newItem);
        console.log("handleAdd newData", newData);
        setConditionValue(newData);
    };
    const handleRemove = (id) => {
        const newData = removeItemById(condition, id);
        setConditionValue(newData);
    };
    const handleChange = (id, updates) => {
        console.log('handleChange with updates ', updates);
        const newData = updateConditionById(condition, id, updates);
        console.log('handleChange with newData ', newData);
        setConditionValue(newData);
    };
    const addItemToParent = (filterCondition, parentId, newItem) => {
        if (filterCondition.id === parentId) {
            return {
                ...filterCondition,
                value: [...(filterCondition.value || []), newItem]
            };
        }
        if (filterCondition.value) {
            return {
                ...filterCondition,
                value: addItemToParent(filterCondition.value, parentId, newItem)
            };
        }
        return filterCondition;
    };
    const removeItemById = (filterCondition, id) => {
        console.log('OadpEntityButtonReadRule removeItemById ', filterCondition, id);
        if (!filterCondition.value) {
            return filterCondition;
        }
        if (!Array.isArray(filterCondition.value)) {
            return filterCondition;
        }
        console.log('OadpEntityButtonReadRule removeItemById filterCondition.value ', filterCondition.value);
        return {
            ...filterCondition,
            value: filterCondition.value.reduce((acc, item) => {
                if (item.id === id) {
                    return acc;
                }
                if (item.value && Array.isArray(item.value)) {
                    return [...acc, {
                            ...item,
                            value: removeItemById(item, id).value
                        }];
                }
                return [...acc, item];
            }, [])
        };
    };
    const updateConditionById = (filterCondition, id, updates) => {
        console.log('updateConditionById with updates ', updates, filterCondition);
        let newFilterCondition = { ...filterCondition };
        if (filterCondition.id === id) {
            newFilterCondition = { ...filterCondition, ...updates };
        }
        if (newFilterCondition.value && Array.isArray(newFilterCondition.value)) {
            newFilterCondition.value = newFilterCondition.value.map((item) => {
                return updateConditionById(item, id, updates);
            });
        }
        return newFilterCondition;
    };
    return (createElement(Box, { direction: "column" },
        createElement(ConditionGroup, { condition: condition, attributeDataSource: attributeDataSource, onAdd: handleAdd, onRemove: handleRemove, onChange: handleChange, handleButtonClick: handleButtonClick })));
};
export default OadpEntityButtonReadRule;
